import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { trackEvent } from "@/utils/tagManagerUtils";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const AutomatisationGoogleAdsFR = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    trackEvent("page_view", { path: "/fr/automatisation-google-ads" });
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>Outil d'automatisation Google Ads | Upfixe</title>
        <meta
          name="description"
          content="Upfixe est l'outil d'automatisation Google Ads par excellence. Économisez des heures de travail manuel, optimisez vos campagnes et laissez l'IA gérer vos publicités."
        />
        <meta
          name="keywords"
          content="automatisation google ads, outil google ads, ia google ads, optimisation ppc"
        />
        <link rel="canonical" href="https://upfixe.com/fr/automatisation-google-ads" />
      </Helmet>

      <Header />

      <main className="flex-grow pt-24 pb-16">
        <section className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center mb-20">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-gray-900 mb-6">
            L'outil d'automatisation <span className="text-primary">Google Ads le plus intelligent</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-10">
            Arrêtez de perdre des heures sur la recherche manuelle de mots-clés et l'ajustement des enchères.
            Upfixe automatise l'ensemble de votre flux de travail Google Ads.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button asChild size="lg" className="text-lg px-8 py-6 rounded-full">
              <a href="https://app.upfixe.com/signup">
                Essai Gratuit <ArrowRight className="ml-2 h-5 w-5" />
              </a>
            </Button>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default AutomatisationGoogleAdsFR;
